import { useEffect } from "react";
import LoadingScreen from "../components/LoadingScreen";

// app.limkc.com has NO auth UI of its own. The apex (limkc.com) is the single
// login / register / forgot-password surface — no duplicate cards here. Any auth
// route on the app bounces to the matching apex page, carrying a return URL so the
// user lands back in the app once the shared .limkc.com session cookie is set.
const APEX = "https://limkc.com";

export default function RedirectToApex({ to = "/login" }) {
  useEffect(() => {
    const ret = encodeURIComponent(window.location.href);
    window.location.replace(`${APEX}${to}?return=${ret}`);
  }, [to]);
  return <LoadingScreen />;
}
